document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelector('.all_trigger').click();
  }, 100);
  let targetDiv = document.querySelector('.top_heading_area');
  let filtersHeader = document.querySelector('.show_tabs');

  if (filtersHeader) {
    filtersHeader.addEventListener('click', function () {
      filtersHeader.classList.toggle('visible');
      targetDiv.classList.toggle('visible');
    });
  }

  let sliderTabNames = document.querySelectorAll('.desk_cat .slider_tab_name');
  let homePageBestSellers = document.querySelector('.home_page_best_seller');
  let tabTriggersMobile = document.querySelectorAll('.products_shift .tab_triggers_mobile');

  sliderTabNames.forEach(function (tabName) {
    tabName.addEventListener('click', function () {
      // Remove active class from all tabs
      sliderTabNames.forEach(function (tab) {
        tab.classList.remove('active');
      });
      this.classList.add('active');
      
      // Update video section visibility
      const tabId = this.id;
      updateVideoSection(tabId);

      // Existing AJAX code for blog content
      homePageBestSellers.style.opacity = '0';
      let collection = this.getAttribute('data-collection');
      let collectionHandle = this.getAttribute('data-collection-handle');
      
      if (collection === 'all') {
        let xhr = new XMLHttpRequest();
        //xhr.open('GET', '/blogs/blog-for-sensitive-skin?view=all-blog', true);
        xhr.open('GET', '/blogs/' + collectionHandle + '?view=all-blog', true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let parser = new DOMParser();
            let responseDoc = parser.parseFromString(xhr.responseText, 'text/html');
            let mainBlog = responseDoc.querySelector('.main-blog');

            homePageBestSellers.innerHTML = '';
            homePageBestSellers.appendChild(mainBlog.cloneNode(true));
            homePageBestSellers.style.opacity = '1';
          }
        };
        xhr.send();
      } else {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', '/blogs/' + collection + '?view=custom-blog-collection', true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let parser = new DOMParser();
            let responseDoc = parser.parseFromString(xhr.responseText, 'text/html');
            let mainBlog = responseDoc.querySelector('.main-blog');

            homePageBestSellers.innerHTML = '';
            homePageBestSellers.appendChild(mainBlog.cloneNode(true));
            homePageBestSellers.style.opacity = '1';
          }
        };
        xhr.send();
      }
    });
  });

  tabTriggersMobile.forEach(function (tabTrigger) {
    tabTrigger.style.display = 'none';
  });

  function loadVideo(blockId) {
    const container = document.querySelector(`.video-with-text[data-block-id="${blockId}"]`);
    if (!container) return;

    const template = container.querySelector('template');
    const videoContainer = container.querySelector('.current-video-with-text-container');
    
    if (template && videoContainer && !videoContainer.hasChildNodes()) {
      const content = template.content.cloneNode(true);
      videoContainer.appendChild(content);
      container.setAttribute('data-video-loading', 'true');
    }
  }

  function updateVideoSection(activeTabId) {
    // Hide all video sections first
    document.querySelectorAll('.video-with-text').forEach(section => {
      section.style.display = 'none';
      section.classList.remove('active');
    });

    // Show and load video for active tab
    const activeVideo = document.querySelector(`.video-with-text[data-block-id="${activeTabId}"]`);
    if (activeVideo) {
      activeVideo.style.display = 'block';
      activeVideo.classList.add('active');
      loadVideo(activeTabId);
    }
  }

  // Show first video section by default
  const firstTab = document.querySelector('.slider_tab_name');
  if (firstTab) {
    updateVideoSection(firstTab.id);
  }

  // Show first tab's video on page load
  setTimeout(function () {
    const allTrigger = document.querySelector('.all_trigger');
    if (allTrigger) {
      updateVideoSection(allTrigger.id);
    }
  }, 100);
});